<template>
    <section class="animated fadeIn">
        <div class="form-group mt-4">
            <label for="title" class="form-label">Title <span class="text-danger">*</span></label>
            <select v-model="form.title" class="form-control" placeholder="Select Title" required>
                <option value="" disabled>Select Title</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
            </select>
        </div>
        <div class="row form-group">
            <div class="col-lg-6">
                <label for="surname" class="form-label">Surname <span class="text-danger">*</span></label>
                <input type="text" v-model="form.lastName" class="form-control" placeholder="Surname" required>
            </div>
            <div class="col-lg-6">
                <label for="firstname" class="form-label">First name <span class="text-danger">*</span></label>
                <input type="text" v-model="form.firstName" class="form-control" placeholder="First Name as on intl. passport" required>
            </div>
        </div>
        <div class="form-group row mt-2">
            <div class="col-lg-6">
                <label for="middlename" class="form-label">Middle name</label>
                <input type="text" v-model="form.middleName" class="form-control" placeholder="Middle Name as on intl. passport">
            </div>
            <!-- <div class="col-lg-6" v-if="optionalDetails">
                <label class="form-label">Address <span class="text-danger">*</span></label>
                <input type="text" v-model="form.address" class="form-control" required placeholder="Enter Address">
            </div> -->
            <div class="col-lg-6" v-if="adult">
                <label for="dob" class="form-label">Date of Birth <span class="text-danger">*</span></label>
                <input type="date" v-model="form.dateOfBirth" :min="'1800-01-01'" :max="maxAdultDate" class="form-control" placeholder="Date of Birth" required>
            </div>
            <div class="col-lg-6" v-if="child">
                <label for="dob" class="form-label">Date of Birth <span class="text-danger">*</span></label>
                <input type="date" v-model="form.dateOfBirth" :min="minChildYear" :max="maxChildYear" class="form-control" placeholder="Date of Birth" required>
            </div>
            <div class="col-lg-6 mt-3" v-if="Infant">
                <label for="dob" class="form-label">Date of Birth <span class="text-danger">*</span></label>
                <input type="date" v-model="form.dateOfBirth" :min="minInfantYear" :max="maxInfantYear" class="form-control" placeholder="Date of Birth" required>
            </div>
            <!-- <div class="col-lg-6">
                <label class="form-label">Age</label>
                <input type="number" v-model.number="form.age" class="form-control" placeholder="Age">
            </div> -->
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label for="nationality" class="form-label">Nationality <span class="text-danger">*</span></label>
                    <select v-model="form.country" placeholder="Nationality" class="form-control" required>
                        <option value="" disabled>Nationality</option>
                        <option v-for="data in allCountries" :key="data.id" :value="data.name">{{ data.name }}</option>
                    </select>
                    <!-- <input type="text" v-model="form.country" class="form-control" placeholder="Nationality" required> -->
                </div>
            </div>
            <div class="col-lg-6" v-if="isPassportRequired">
                <div class="form-group">
                    <label for="city" class="form-label">City</label>
                    <input type="text" v-model="form.city" class="form-control" placeholder="Enter City">
                </div>
            </div>
            <div class="col-lg-6" v-if="isPassportRequired">
                <div class="form-group">
                    <label for="postalCode" class="form-label">Postal Code</label>
                    <input type="text" v-model="form.postalCode" @keypress="isNumber" class="form-control" placeholder="Enter Postal Code">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label for="gender" class="form-label">Gender <span class="text-danger">*</span></label>
                    <select v-model="form.gender" class="form-control" placeholder="Select" required>
                        <option value="" disabled>Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group row mt-2" v-if="isPassportRequired">
            <div class="col-lg-6">
                <label class="form-label">Passport Number <span class="text-danger">*</span></label>
                <input type="text" @click="removeReadonly" :id="`no-paste-${id}`" v-model="form.passportNumber" class="form-control" placeholder="Passport Number" required>
            </div>
            <div class="col-lg-6">
                <label class="form-label">Expiry Date <span class="text-danger">*</span></label>
                <input type="date" v-model="form.expiryDate" class="form-control" placeholder="Expiry Date" required>
            </div>
        </div>
        <div class="row form-group" v-if="isPassportRequired">
            <div class="col-lg-6">
                <label class="form-label">Passport Issuing Authority <span class="text-danger">*</span></label>
                <input type="text" v-model="form.passportIssuingAuthority" class="form-control" placeholder="Passport Issuing Authority" required>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-lg-12">
                <label class="form-label">Address</label>
                <textarea v-model="form.address" class="form-control" placeholder="Enter Address"></textarea>
            </div>
        </div>
    </section>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    filters: {
      dayjs: function (date) {
        return dayjs(date).format('hh:mma');
      },
      momentDate: function (date) {
        return moment(date).format('DD MMM, YYYY');
      }
    },
    props: {
        id: {
            type: Number,
            required: false
        },
        submit: {
            type: Boolean,
            required: true
        },
        optionalDetails: {
            type: Boolean,
            required: false,
            default: false
        },
        adult: {
            type: Boolean,
            required: false,
            default: false
        },
        child: {
            type: Boolean,
            required: false,
            default: false
        },
        Infant: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        submit() {
            this.$emit('new-data', this.form)
        },
    },
    data:() => ({
      form: {
        title: '',
        passengerType: '',
        firstName: '',
        lastName: '',
        middleName: '',
        dateOfBirth: '',
        age: '',
        address: '',
        passportNumber: '',
        expiryDate: '2025-02-02',
        gender: '',
        city: '',
        country: '',
        postalCode: '',
        passportIssuingAuthority: ''
      },
    }),
    computed: {
        ...mapState('flight', ['selectedFlight', 'bookingData', 'allCountries', 'multiWayDate', 'roundTripDate', 'oneWayDate', 'flightType']),
        typeOfFlight() {
            let type = ''
            switch (this.flightType) {
                case 'Return':
                    type = this.roundTripDate
                    break;
                case 'Oneway':
                    type = this.oneWayDate
                    break;
                case 'Multidestination':
                    type = this.multiWayDate
                    break;
                default:
                    break;
            }
            return type
        },
        maxAdultDate () {
            return `${this.typeOfFlight.getFullYear() - 13}-${this.typeOfFlight.getMonth() + 1}-${this.typeOfFlight.getDate()}`
        },
        minChildYear() {
            return `${this.typeOfFlight.getFullYear() - 12}-${this.typeOfFlight.getMonth() + 1}-${this.typeOfFlight.getDate()}`
        },
        maxChildYear () {
            return `${this.typeOfFlight.getFullYear() - 2}-${this.typeOfFlight.getMonth() + 1}-${this.typeOfFlight.getDate()}`
        },
        minInfantYear () {
            return `${this.typeOfFlight.getFullYear() - 2}-${this.typeOfFlight.getMonth() + 1}-${this.typeOfFlight.getDate()}`
        },
        maxInfantYear () {
            return `${this.typeOfFlight.getFullYear()}-${this.typeOfFlight.getMonth() + 1}-${this.typeOfFlight.getDate()}`
        },
        isPassportRequired () {
            return this.selectedFlight.isPassportRequired
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('flight', ['getAllCountries']),
      removeReadonly() {
        document.getElementById(`no-paste-${this.id}`).removeAttribute('readonly');
      }
    }
  };
</script>

<style scoped>
.search-body {
  height: 100%;
  padding: 0 30px;
  margin: 0;
  background-color: #EAF0F3;
}
.view__header {
    background: #EAF0F3;
    height: 100%;
    padding-top: 40px;
    padding-bottom: 10px;
}
.view__header--text {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-weight: bold;
    font-size: 15px;
}
.notification-header {
    padding: 10px;
    background: #D4EDDA 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 789px;
}
.notification-text {
    letter-spacing: 0.3px;
    color: #155724;
    opacity: 1;
    margin-bottom: 0;
}
.tab-section {
    height: 42px;
    background: #E1ECF3 0% 0% no-repeat padding-box;
    opacity: 1;
}
.tab-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    width: 350px;
    margin: 0 auto;
    cursor: pointer;
}
.tab-items h5 {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 16px;
    font-weight: 500;
}
.tab-items h5:last-child {
    color: #818F9B;
}
.tab__section {
    padding: 10px 50px;
}
.right-side {
    height: 500px;
    overflow: scroll;
}
.right-side-form {
    height: 700px;
    overflow: scroll;
}
.line {
    height: 1px;
    background: #E1ECF3;
    border: 1px dotted #E1ECF3;
    width: 90%;
    margin: 10px 0px;
}
.line-1 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #6D757D;
    margin: 20px 0px;
}
.line-2 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #E1ECF3;
    margin: 20px 0px;
}
.departure-header {
    letter-spacing: 0.4px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.fare-summary {
    width: 375px;
    height: 100%;
    background: #223344 0% 0% no-repeat padding-box;
    opacity: 1;
    /* position: fixed; */
}
.flight-luggage {
    background: #FDF9EC 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 20px;
    width: 90%;
}
.flight-luggage p {
    letter-spacing: 0.34px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
}
.flight-about-date {
    letter-spacing: 0.34px;
    color: #818F9B;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.airport-name {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
    font-weight: normal;
    width: 387px;
}
.flight-type {
    letter-spacing: 0.3px;
    color: #818F9B;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.flight-time {
    letter-spacing: 0.34px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.traveler-text h5,
.trav-amount {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.traveler-text h6 {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.rules h6 {
    letter-spacing: 0.36px;
    color: #3A4248;
    opacity: 1;
    font-size: 18px;
}
.rules p {
    letter-spacing: 0.24px;
    color: #3A4248;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.sub-text {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
}
.continue-booking {
    background: #FFFFFF;
    opacity: 1;
}
.booking-header h5 {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 17px;
    font-weight: bold;
}
.booking-notification-header {
    background: #F2F2FF 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 10px 15px;
}
.booking-notification-text {
    letter-spacing: 0.3px;
    color: #6569B5;
    opacity: 1;
    margin-bottom: 0;
    font-size: 11px;
}
.booking-pass-text {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.fa-angle-down {
    cursor: pointer;
}
input::placeholder,
textarea::placeholder,
option {
    font-size: 14px;
    color: #ACACAC;
    font-weight: 400;
}
.p-text {
    letter-spacing: 0.28px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: bold;
}
.sub-p-text {
    letter-spacing: 0.28px;
    color: #6D8494;
    opacity: 1;
    font-weight: normal;
    font-size: 13px;
    margin-bottom: 4px;
}
.arrives-text {
    letter-spacing: 0.28px;
    font-size: 13px;
    margin-bottom: 0;
    color: #E41613;
}
.total-sec h5 {
    letter-spacing: 0px;
    color: #6D8494;
    opacity: 1;
    font-size: 18px;
}
.total-sec h6 {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 18px;
}
.footer-sec {
    background: #FFF0E4;
    padding: 15px 20px;
    text-align: center;
    color: #223344;
    opacity: 1;
}
.footer-sec p {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
}
.details-section {
    /* padding: 40rem 0; */
    padding-top: 5rem;
}
.payment-header {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    margin-bottom: 0;
    font-size: 18px;
}
.border-sm {
    border-radius: 7px;
}
.otpPage p {
    letter-spacing: -0.18px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
}
.otpPage h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
}
.succes-page h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
    margin-top: 50px;
}
.succes-page p {
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
    margin-top: 30px;
    margin-bottom: 60px;
}
.active-border {
    border-bottom: 2px solid #F58220;
}
.show-pin {
  font-size: 12px;
  color: #E41613;
  cursor: pointer;
}
</style>